export const GET_AVAILABLE_DELEGATION_TYPES = "GET_AVAILABLE_DELEGATION_TYPES";
export const GET_AVAILABLE_SUBSTITUTION_TYPES = "GET_AVAILABLE_SUBSTITUTION_TYPES";
export const GET_AVAILABLE_EMPLOYEES_DELEGATION = "GET_AVAILABLE_EMPLOYEES_DELEGATION";

export const GET_ERROR_NOTIFICATION_CONTENT = "GET_ERROR_NOTIFICATION_CONTENT";
export const CLEAR_ERROR_NOTIFICATION_CONTENT = "CLEAR_ERROR_NOTIFICATION_CONTENT";
export const CLEAR_AVAILABLE_EMPLOYEES_DELEGATION = "CLEAR_AVAILABLE_EMPLOYEES_DELEGATION";

export const GET_ACTIVE_DELEGATIONS = "GET_ACTIVE_DELEGATIONS";
